import React from "react";
import { Box, Heading } from "@chakra-ui/layout";
import { Checkpoint } from "components/atoms/Checkpoint";
import { HiCheck } from "react-icons/hi";

export const FeatureCard = ({ title, description, body, icon, color }: any) => {
  return (
    <Box display="flex">
      <Box>
        <Heading fontSize="lg" mb={2} fontWeight={700}>
          {title}
        </Heading>
        <Box fontSize="md" color="gray.600">
          {body}
        </Box>
      </Box>
    </Box>
  );
};
